import React, { Component } from 'react';
import GridRow from './GridRow';

class GridBody extends Component {
 
  constructor(props) {
    super(props);

    this.state = {
      selectedRowIndex: 0,
    };

    this.handleRowClick = this.handleRowClick.bind(this);
  }


  handleRowClick(rowIndex) {
    const { rows, groupField } = this.props;

    // Get the selected row
    const selectedRow = rows.find((row) => row.index === rowIndex);

    // Determine the group value for the selected row
    const selectedGroupValue = groupField ? selectedRow[groupField] : null;

    this.setState({
      selectedRowIndex: rowIndex,
      selectedGroupValue: selectedGroupValue, // Save the group value for group selection
    });

    // Notify parent (if needed)
    if (this.props.onRowClick) {
      this.props.onRowClick(selectedRow);
    }
  }


  render() {
    let previousGroupValue = null; // Tracks previous group field value
    let isGroup = null;
    return (
      <tbody ref={this.props.tbodyRef}>
        {(this.props.rows || []).map((row, index) => {
          let isSelected = this.state.selectedRowIndex === row.index
          if (this.props.groupField) {
            const currentGroupValue = this.props.groupField ? row[this.props.groupField] : null;
            isGroup = currentGroupValue === (previousGroupValue != null ? previousGroupValue : currentGroupValue);
            previousGroupValue = currentGroupValue; 
            isSelected = this.props.groupField && this.state.selectedGroupValue === row[this.props.groupField];
          }
          return (
            <GridRow columns={this.props.columns} row={row} key={index} onRowClick={this.handleRowClick} isSelected={isSelected} group={isGroup} />)}         
        )}
      </tbody>
    );
  }

};

export default GridBody;



// WEBPACK FOOTER //
// ./src/common/core/grid/GridBody.jsx